module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-service"
  }, [_c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("便民生活")]), _vm._v(" "), _c('div', {
    staticClass: "ctx"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('a', {
      key: index,
      staticClass: "item",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.menuClick(item)
        }
      }
    }, [(item.img == undefined) ? _c('div', [_c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": item.icon
      }
    })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.menuName))])]) : _vm._e(), _vm._v(" "), (item.img != undefined && item.menuType != 3) ? _c('div', [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.menuName))])]) : _vm._e(), _vm._v(" "), (item.menuType == 3) ? _c('div', [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.menuName))]), _vm._v(" "), _c('wx-open-launch-weapp', {
      class: 'launch-btn-' + index,
      staticStyle: {
        "height": "60px",
        "width": "100%",
        "position": "absolute",
        "top": "0",
        "left": "0",
        "z-index": "10"
      },
      attrs: {
        "username": item.miniId,
        "path": item.url
      }
    }, [_c('script', {
      attrs: {
        "type": "text/wxtag-template"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t<div style=\"height: 2rem;width: 2rem;opacity: 0\"></div>\n\t\t\t\t\t\t")])])], 1) : _vm._e()])
  }))]), _vm._v(" "), (_vm.isShowHealth) ? _c('HealthDialog', {
    attrs: {
      "show": _vm.isShowHealth
    },
    on: {
      "close": _vm.closeHealth
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowPayment) ? _c('PaymentDialog', {
    attrs: {
      "show": _vm.isShowPayment
    },
    on: {
      "close": _vm.closePayment
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowOperator) ? _c('OperatorDialog', {
    attrs: {
      "show": _vm.isShowOperator
    },
    on: {
      "close": _vm.closeOperator
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowDialog) ? _c('DetailDialog', {
    attrs: {
      "show": _vm.isShowDialog,
      "title": _vm.dialogTitle,
      "list": _vm.dialogList
    },
    on: {
      "close": _vm.closeDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dcbe226"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/provincial_level/human_service/human_service.vue
// module id = 311
// module chunks = 40